module.exports = "<button class=\"d-inline-flex justify-content-center align-items-center notification-btn\" type=button ui-sref=app.dashboard.mailbox.admin gmc-tooltip={{$ctrl.getTooltipMessage()}}><i class=material-icons>add_alert</i><div class=topbar-notification__unread-count ng-if=\"$ctrl.unreadCount > 0\">+{{$ctrl.unreadCount}}</div></button>";


//////////////////
// WEBPACK FOOTER
// ./app/states/dashboard/components/topbar-notification/topbar-notification.component.html
// module id = 907
// module chunks = 31